import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { COMPANY } from "@/lib/translations";

const LABELS = {
  pt: { call: "Chamar Táxi", instant: "Imediato" },
  en: { call: "Call Taxi", instant: "Instant" },
  es: { call: "Llamar Taxi", instant: "Inmediato" },
};

const FloatingButtons = () => {
  const { lang } = useLang();
  const l = LABELS[lang] || LABELS.pt;

  return (
    <>
      {/* Desktop & tablet: expanded pill — "Chamar Táxi" + WhatsApp dot */}
      <div
        data-testid="floating-buttons"
        className="hidden sm:flex fixed bottom-6 right-6 z-50 items-center gap-3"
      >
        <a
          href={COMPANY.whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="fab-whatsapp"
          aria-label="WhatsApp"
          className="fab fab-wa"
        >
          <MessageCircle className="h-6 w-6" />
        </a>
        <a
          href={COMPANY.telLink}
          data-testid="fab-call"
          aria-label="Chamar Táxi"
          className="call-pill relative"
        >
          <span className="call-pulse" aria-hidden="true" />
          <Phone className="h-5 w-5 relative" />
          <span className="flex flex-col leading-tight text-left relative">
            <span className="text-[10px] tracking-[0.25em] uppercase opacity-80">
              {l.instant}
            </span>
            <span className="text-sm font-semibold tracking-wide">{l.call}</span>
          </span>
        </a>
      </div>

      {/* Mobile sticky bottom bar — full-width "Chamar Táxi Agora" */}
      <div
        data-testid="mobile-bottom-bar"
        className="sm:hidden fixed bottom-0 left-0 right-0 z-50 bg-black/85 backdrop-blur-xl border-t border-white/10 px-3 py-3 flex items-center gap-2"
      >
        <a
          href={COMPANY.whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-bar-whatsapp"
          aria-label="WhatsApp"
          className="fab fab-wa !w-12 !h-12 shrink-0"
        >
          <MessageCircle className="h-5 w-5" />
        </a>
        <a
          href={COMPANY.telLink}
          data-testid="mobile-bar-call"
          className="call-pill flex-1 justify-center relative"
        >
          <span className="call-pulse" aria-hidden="true" />
          <Phone className="h-5 w-5 relative" />
          <span className="font-semibold tracking-wide relative">{l.call}</span>
        </a>
      </div>
    </>
  );
};

export default FloatingButtons;
